import { Injectable, Inject } from '@angular/core';
import { UserEventAdd } from '../models/user-event.model';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from '../utilities/route';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserEventService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    public getLatestUserEvent(userId: number, eventType: number, pageName: string): Observable<Date | null> {
        const url = `${this.coreApiPath}/UserEvent/Latest/${userId}/${eventType}/${pageName}`;

        return this.http.get<Date | null>(url, { observe: 'response' }).pipe(
            map((resp) => {
                return resp.body;
            })
        );
    }

    public addUserEvent(userEvent: UserEventAdd): Observable<any> {
        const url = `${this.coreApiPath}/UserEvent`;
        return this.http.post(url, userEvent);
    }
}
